
import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DashboardLayout from './components/DashboardLayout';
import DashboardHome from './components/DashboardHome';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import EventJoinees from './pages/EventJoinees';
import Directory from './pages/Directory';
import Grievances from './pages/Grievances';
import Constituency from './pages/Constituency';
import Users from './pages/Users';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Calendar from './pages/Calendar';
import News from './pages/News';
import ProtectedRoute from './components/ProtectedRoute';

const theme = createTheme({
  palette: {
    primary: {
      main: '#CE1F30',
      light: '#CE1F30',
      dark: '#CE1F30',
      contrastText: '#fff',
    },
    success: {
      main: '#CE1F30',
      light: '#CE1F30',
      dark: '#CE1F30',
      contrastText: '#fff',
    },
    secondary: {
      main: '#000000',
      light: '#333333',
      dark: '#000000',
      contrastText: '#fff',
    },
    background: {
      default: '#f8fafc',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Router>
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<Login />} />

            {/* Protected Dashboard Routes */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Routes>
                      <Route path="/" element={<DashboardHome />} />
                      <Route path="/events" element={<Events />} />
                      <Route path="/gallery" element={<Gallery />} />
                      <Route path="/event-joinees" element={<EventJoinees />} />
                      <Route path="/directory" element={<Directory />} />
                      <Route path="/grievances" element={<Grievances />} />
                      <Route path="/constituency" element={<Constituency />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/calendar" element={<Calendar />} />
                      <Route path="/news" element={<News />} />
                      <Route path="/profile" element={<Profile />} />
                    </Routes>
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;

